import i18n from '../../language/index'
const image_upload = {
  namespaced: true,
  state: {
    //文件库参数
    showTag: false,
    imgFile: null,
    fileType: 1,  // 之前是：1图片 2视频 3文档 // 后来改成：1:图片,2:文档，3:视频，4:音乐，0:其他，9 默认选中我的文件，与资源库保持一致
    fileLimit: 1,
    limitMessage: i18n.t('vuex_modules_image_upload_309'),
    isEditMode: false,
    showFontIcon: false,  // 是否显示文字图标库
    showIconLibrary: false,  // 是否显示图标库
    selectLine: 0, // 资源库当前选择的栏目
    sePicTab: 'img', // 图片库默认选择的标签（图片img、图标icon）
    isDownload: false, // 是否为下载
    TYPE_IMG: 1,
    TYPE_DOCUMENT: 2,
    TYPE_VIDEO: 3,
    TYPE_MUSIC: 4,
    TYPE_OTHER: 0,
    TYPE_MY_FILE: 9,
    defaultFilterPlatform: [
      {
        value: 'jpt',
        label: i18n.t('view_index_60')
      },
      {
        value: 'ztg',
        label: i18n.t('vuex_modules_image_upload_310')
      },
      {
        value: 'czh',
        label: i18n.t('vuex_modules_image_upload_311')
      },
      {
        value: 'ztb',
        label: i18n.t('vuex_modules_image_upload_312')
      },
      {
        value: 'st',
        label: i18n.t('vuex_modules_image_upload_313')
      },
      {
        value: 'zt',
        label: i18n.t('vuex_modules_image_upload_314')
      },
      {
        value: 'other',
        label: i18n.t('vuex_modules_image_upload_315')
      }
    ],
    isOld:false, //是否弹出老的资源库
  },
  mutations: {
    set_showTag(state, val, isEditMode = false) {
      state.showTag = val;
      state.isEditMode = isEditMode
    },
    set_fileType(state, val) {
      state.fileType = val;
    },
    set_fileLimit(state, val) {
      state.fileLimit = val;
    },
    set_limitMessage(state, val) {
      state.limitMessage = val;
    },
    set_showFontIcon(state, val) {
      state.showFontIcon = val;
    },
    set_showIconLibrary(state, val) {
      state.showIconLibrary = val;
    },
    set_selectLine(state, val) {
      state.selectLine = val;
    },
    set_sePicTab(state, val) {
      state.sePicTab = val;
    },
    set_isDownload(state, val) {
      state.isDownload = val;
    },
    set_isOld(state, val) {
      state.isOld = val;
    },
  },
  actions: {}

};
export default image_upload;



// WEBPACK FOOTER //
// ./src/vuex/modules/image_upload.js